// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement, Component, Translate, PropTypes, classNames, Button, Toaster } from '@plesk/ui-library';
import { withRouter } from 'react-router-dom';
import Link from '../../../plesk/Link';
import TextEditor from './TextEditor';
import CodeEditor from './CodeEditor';

const MODE_SHOW = 'show';
const MODE_EDIT = 'edit';
const MODE_CODE = 'code-editor';
const MODE_HTML = 'wysiwyg';

const URL_CLOSE = '/smb/file-manager/close/';
const URL_CANCEL = '/smb/file-manager/list';
const URL_SHOW = '/smb/file-manager/show/';
const URL_IMAGE = '/smb/file-manager/show-image/';
const URL_EDIT = '/smb/file-manager/edit/';
const URL_CODE = '/smb/file-manager/code-editor/';
const URL_WYSIWYG = '/smb/file-manager/wysiwyg/';

class FileEditor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rawContent: this.props.content,

            tabs: JSON.parse(JSON.stringify(this.props.tabs)),
            content: this.props.content,
            codepage: this.props.codepage,
            saveCodepage: this.props.codepage,
            eol: this.props.eol,
            saveAs: false,

            loading: false,
            saving: false,
            leaveBlock: false,
            leaveBlockPopup: false,
        };
    }

    componentWillReceiveProps(props) {
        const newState = {
            rawContent: props.content,

            tabs: props.tabs,
            content: props.content,
            codepage: props.codepage,
            saveCodepage: props.codepage,
            eol: props.eol,
        };

        const {
            content,
            tabs,
        } = this.props;

        if (props.content !== content || props.tabs !== tabs) {
            newState.loading = false;
        }

        this.setState(newState);
    }

    componentWillUnmount() {
        Event.stopObserving(window, 'resize', this.handleWindowResize);
    }

    getCurrentModeUrl = () => {
        switch (this.props.mode) {
            case MODE_SHOW:
                return URL_SHOW;

            case MODE_EDIT:
                return URL_EDIT;

            case MODE_CODE:
                return URL_CODE;

            case MODE_HTML:
                return URL_WYSIWYG;
        }

        return '';
    };

    checkEditorHeight() {
        const buttons = $$('.btns-box')[0];

        let height = document.viewport.getHeight();
        height -= $$('.page-footer-wrapper')[0].getHeight();
        height -= parseFloat($$('.page-content')[0].getStyle('padding-bottom'));
        height -= buttons.getHeight();
        height -= buttons.cumulativeOffset().top;

        height += this.codeNode.getHeight();

        this.codeNode.setStyle({ height: `${height > 300 ? height : 300}px` });
    }

    handleWindowResize = () => {
        this.checkEditorHeight();
    };

    handleEditorInit = codeNode => {
        this.codeNode = codeNode;

        if (this.codeNode) {
            Event.observe(window, 'resize', this.handleWindowResize);
            this.checkEditorHeight();
        }
    };

    handleCodepageChange = event => {
        this.setState({ codepage: event.target.value });
    };

    handleSaveCodepageChange = event => {
        this.setState({ saveCodepage: event.target.value });
    };

    handleEolChange = event => {
        this.setState({ eol: event.target.value });
    };

    handleChangeTab = index => {
        const { tabs, saving } = this.state;
        const { queryStr } = tabs[index];

        if (saving) {
            return;
        }

        tabs.forEach((tab, ind) => {
            tab.active = ind === index;
            tab.disableClose = true;
            tab.queryStr = null;
        });

        this.setState({ tabs, loading: true }, () => {
            this.props.history.push(URL_CODE + queryStr);
        });
    };

    handleCloseTab = index => {
        const { tabs, leaveBlockPopup } = this.state;
        const tab = tabs[index];
        let promise = Promise.resolve(true);

        if (tab.active && leaveBlockPopup) {
            // ask for discard changes
            promise = promise.then(() => new Promise(resolve => leaveBlockPopup(resolve)));
        }

        promise.then(() => {
            const closeUrl = URL_CLOSE + tab.queryStr;

            new Ajax.Request(closeUrl, {
                method: 'POST',
                onCreate: () => {
                    tab.disableClose = true;
                    this.setState({ tabs, loading: tab.active });
                },
                onComplete: () => {
                    if (tab.active) {
                        if (tabs.length === 1) {
                            // the last one
                            // redirect
                            this.props.history.push(URL_CANCEL);
                        } else {
                            // if it is the first tab then next will be the first one, otherwise next will be previous tab
                            const newIndex = index + (index ? -1 : 0);

                            tabs.splice(index, 1);
                            tabs[newIndex].active = true;
                            this.setState({ tabs });
                            this.handleChangeTab(newIndex);
                        }
                    } else {
                        tabs.splice(index, 1);
                        this.setState({ tabs });
                    }
                },
            });
        });
    };

    handleContentChange = content => {
        const { locale } = this.context;
        const { rawContent, leaveBlock, tabs } = this.state;
        const newState = { content };
        const contentChanged = content !== rawContent;

        if (!contentChanged && leaveBlock) {
            // remove block
            leaveBlock();
            newState.leaveBlock = false;
            newState.leaveBlockPopup = false;
        } else if (contentChanged && !leaveBlock) {
            const savedTabs = JSON.parse(JSON.stringify(tabs));
            const cancel = () => {
                this.setState({ loading: false, tabs: JSON.parse(JSON.stringify(savedTabs)) });
            };
            newState.leaveBlockPopup = callback => {
                let buttonClicked = false;

                Jsw.messageBox.show({
                    text: locale.lmsg('exitConfirmation'),
                    description: locale.lmsg('exitConfirmationDescription'),
                    type: Jsw.messageBox.TYPE_YESNO,
                    onYesClick: () => {
                        buttonClicked = true;
                        const { leaveBlock: actualLeaveBlock, rawContent: actualRawContent } = this.state;
                        actualLeaveBlock();
                        this.setState({ content: actualRawContent, leaveBlock: false, leaveBlockPopup: false }, () => {
                            callback();
                        });
                    },
                    onNoClick: () => {
                        buttonClicked = true;
                        cancel();
                    },
                    onHide: () => {
                        setTimeout(() => !buttonClicked ? cancel() : 0, 0);
                    },
                    buttonTitles: {
                        yes: locale.lmsg('exitConfirmationYes'),
                        no: locale.lmsg('exitConfirmationNo'),
                    },
                });
            };
            // add block
            newState.leaveBlock = this.props.history.block(location => {
                newState.leaveBlockPopup(() => this.props.history.push(location));

                return JSON.stringify({ callback: false });
            });
        }

        this.setState(newState);
    };

    handleReset = () => {
        const { history, location } = this.props;
        const { leaveBlock } = this.state;

        if (leaveBlock) {
            leaveBlock();
            this.setState({
                leaveBlock: false,
                leaveBlockPopup: false,
            });
        }

        history.replace(location);
    };

    handleSaveAs = () => {
        const { locale } = this.context;

        new Smb.FileManager.FileNamePopupForm({
            id: 'saveAsPopup',
            cls: 'popup-panel',
            handler: fileName => {
                const onConfirmationRequired = () => {
                    let buttonClicked = false;
                    Jsw.messageBox.show({
                        text: locale.lmsg('fileOverwrite'),
                        description: locale.lmsg('fileOverwriteDescription'),
                        type: Jsw.messageBox.TYPE_YESNO,
                        onYesClick: () => {
                            buttonClicked = true;
                            onSave(true);
                        },
                        onNoClick: () => {
                            buttonClicked = true;
                            this.handleSaveAs();
                        },
                        onHide: () => {
                            if (!buttonClicked) {
                                setTimeout(() => this.handleSaveAs(), 0);
                            }
                            this.setState({ saving: false, tabs: this.props.tabs });
                        },
                        buttonTitles: {
                            yes: locale.lmsg('exitConfirmationYes'),
                            no: locale.lmsg('exitConfirmationNo'),
                        },
                    });
                };
                const onSave = overwrite => {
                    this.setState({ saveAs: fileName }, () => {
                        this.handleApply(
                            false,
                            overwrite,
                            () => {
                                // redirect
                                this.props.history.push(URL_CANCEL);
                            },
                            onConfirmationRequired,
                        );
                    });
                };

                onSave();
            },
            locale: {
                popupTitle: locale.lmsg('popupTitle'),
                popupFilename: locale.lmsg('popupFilename'),
                buttonOk: locale.lmsg('buttonOk'),
                buttonCancel: locale.lmsg('buttonCancel'),
            },
        });
    };

    handleOk = () => {
        this.handleApply(true, false, () => {
            // redirect
            this.props.history.push(URL_CANCEL);
        });
    };

    handleApply = (onlyChanged = true, overwrite = false, onSuccess = null, onConfirmationRequired = null) => {
        const {
            rawContent,
            content,
            codepage,
            saveCodepage,
            eol,
            tabs,
            saveAs,
            saving,
        } = this.state;

        if (saving || (onlyChanged && content === rawContent)) {
            return;
        }

        const savedTabs = JSON.parse(JSON.stringify(tabs));
        if (tabs) {
            tabs.forEach(tab => {
                tab.disableClose = true;
                tab.queryStr = null;
            });
        }

        this.setState({ saving: true });

        new Ajax.Request(location.href, {
            parameters: {
                overwrite,
                content,
                codepage,
                saveCodepage,
                eol,
                saveAs: saveAs || '',
            },
            onSuccess: ({ responseJSON: { status, message, statusMessages } }) => {
                if (status === 'confirmationRequired') {
                    if (typeof onConfirmationRequired === 'function') {
                        onConfirmationRequired(message);
                    }

                    return;
                }

                if (status === 'error') {
                    this.setState({
                        saving: false,
                    });
                    statusMessages.forEach(({ content }) => {
                        this.toaster.add({
                            intent: 'danger',
                            // eslint-disable-next-line react/no-danger
                            message: <span dangerouslySetInnerHTML={{ __html: content }} />,
                        });
                    });

                    return;
                }

                this.setState({
                    rawContent: content,
                    saving: false,
                    tabs: savedTabs,
                }, () => {
                    this.handleContentChange(this.state.content);

                    if (typeof onSuccess === 'function') {
                        onSuccess();
                    }
                });

                const key = this.toaster.add({ intent: 'success', message });
                setTimeout(() => this.toaster.remove(key), 3000);
            },
        });
    };

    render() {
        const {
            mode,

            readonly,
            isWebpage,
            isImage,

            codepageList: codepageListRaw,

            eolList: eolListRaw,

            getParams,
        } = this.props;

        const {
            rawContent,
            tabs,
            content,
            codepage,
            saveCodepage,
            eol,
            loading,
            saving,
        } = this.state;

        const codepageList = codepageListRaw ? Object.keys(codepageListRaw).map(key => ({ key, value: codepageListRaw[key] })) : null;
        const eolList = eolListRaw ? Object.keys(eolListRaw).map(key => ({ key, value: eolListRaw[key] })) : null;

        const actionsDisabled = saving || loading;
        const contentChanged = content !== rawContent;

        const buttons = [];
        if (!readonly && !isImage && mode === MODE_SHOW) {
            buttons.push(
                <Button key="code" className="btn" component={Link} to={URL_CODE + getParams} disabled={actionsDisabled}>
                    <Translate content="buttonTextCodeEditor" />
                </Button>
            );
            buttons.push(
                <Button key="text" className="btn" component={Link} to={URL_EDIT + getParams} disabled={actionsDisabled}>
                    <Translate content="buttonTextEdit" />
                </Button>
            );
            if (isWebpage) {
                buttons.push(
                    <Button key="html" className="btn" component={Link} to={URL_WYSIWYG + getParams} disabled={actionsDisabled}>
                        <Translate content="buttonWysiwygEdit" />
                    </Button>
                );
            }
        }
        if (!isImage && mode !== MODE_SHOW) {
            buttons.push(
                <Button key="reset" className="btn" onClick={this.handleReset} disabled={!contentChanged || actionsDisabled}>
                    <Translate content="buttonReset" />
                </Button>
            );
            buttons.push(
                <Button key="saveAs" className="btn" onClick={this.handleSaveAs} disabled={actionsDisabled}>
                    <Translate content="buttonSaveAs" />
                </Button>
            );
            buttons.push(
                <Button key="ok" className="btn action" name="send" onClick={this.handleOk} disabled={!contentChanged || actionsDisabled} state={saving ? 'loading' : null}>
                    <Translate content="buttonOk" />
                </Button>
            );
            buttons.push(
                <Button key="apply" className="btn action" onClick={this.handleApply} disabled={!contentChanged || actionsDisabled} state={saving ? 'loading' : null}>
                    <Translate content="buttonApply" />
                </Button>
            );
        }
        buttons.push(
            <Button key="cancel" className="btn" component={Link} to={URL_CANCEL} disabled={actionsDisabled}>
                <Translate content="buttonCancel" />
            </Button>
        );

        const baseClassName = 'file-manager';

        return (
            <div className={classNames(baseClassName, loading && `${baseClassName}--loading`)}>
                {(!isImage && mode !== MODE_CODE) && (
                    <fieldset>
                        <legend>
                            <Translate content="loadCodepage" />
                        </legend>
                        <select value={codepage} onChange={this.handleCodepageChange}>
                            {codepageList.map(({ key, value }) => (
                                <option value={key} key={key}>
                                    {value}
                                </option>
                            ))}
                        </select>

                        &nbsp;

                        <Button
                            component={Link}
                            to={`${this.getCurrentModeUrl()}${getParams}&load_codepage=${codepage}`}
                            disabled={actionsDisabled}
                        >
                            <Translate content="buttonReload" />
                        </Button>

                        <p className="hint">
                            <Translate content="loadCodepageHint" />
                        </p>
                    </fieldset>
                )}

                {(mode === MODE_SHOW || mode === MODE_EDIT) && (
                    <TextEditor
                        id="code"
                        rows={25}
                        cols={80}
                        readonly={mode === MODE_SHOW || readonly}
                        onInit={this.handleEditorInit}
                        onChange={this.handleContentChange}
                        onSave={this.handleApply}
                        autoFocus={mode === MODE_EDIT}
                    >
                        {content}
                    </TextEditor>
                )}

                {mode === MODE_CODE && (
                    <CodeEditor
                        id="code"
                        rows={25}
                        cols={80}
                        readonly={readonly}
                        tabs={tabs}
                        onInit={this.handleEditorInit}
                        onChange={this.handleContentChange}
                        onChangeTab={this.handleChangeTab}
                        onCloseTab={this.handleCloseTab}
                        onSave={this.handleApply}
                    >
                        {content}
                    </CodeEditor>
                )}

                {isImage && <input type="image" name="showImage" src={URL_IMAGE + getParams} disabled />}

                {(mode === MODE_EDIT || mode === MODE_HTML) && (
                    <div className="form-row">
                        <div className="field-name">
                            <label htmlFor="saveCodepage">
                                <Translate content="saveCodepage" />
                            </label>
                        </div>
                        <div className="field-value">
                            <select id="saveCodepage" value={saveCodepage} onChange={this.handleSaveCodepageChange}>
                                {codepageList.map(({ key, value }) => (
                                    <option value={key} key={key}>
                                        {value}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                )}

                {(mode === MODE_EDIT || mode === MODE_HTML) && (
                    <div className="form-row">
                        <div className="field-name">
                            <label htmlFor="eol">
                                <Translate content="eolLabel" />
                            </label>
                        </div>
                        <div className="field-value">
                            <select id="eol" value={eol} onChange={this.handleEolChange}>
                                {eolList.map(({ key, value }) => (
                                    <option value={key} key={key}>
                                        {value}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                )}

                <div className="btns-box">
                    <div className="form-row">
                        <div className="field-name" />
                        <div className="field-value">
                            {buttons}
                        </div>
                    </div>
                </div>
                <Toaster ref={ref => (this.toaster = ref)} />
            </div>
        );
    }
}

FileEditor.contextTypes = {
    locale: PropTypes.object,
};
FileEditor.propTypes = {
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,

    mode: PropTypes.oneOf([
        MODE_SHOW,
        MODE_EDIT,
        MODE_CODE,
        MODE_HTML,
    ]).isRequired,

    content: PropTypes.string.isRequired,
    readonly: PropTypes.bool,
    isWebpage: PropTypes.bool,
    isImage: PropTypes.bool,

    codepage: PropTypes.string,
    codepageList: PropTypes.object,

    eol: PropTypes.string.isRequired,
    eolList: PropTypes.object.isRequired,

    getParams: PropTypes.string,

    tabs: PropTypes.any,
};
FileEditor.defaultProps = {
    readonly: false,
    isWebpage: false,
    isImage: false,

    codepage: '',
    codepageList: {},

    getParams: '',

    tabs: null,
};

export default withRouter(FileEditor);



// WEBPACK FOOTER //
// ./views/smb/file-manager/FileEditor.js